export enum PaymentGates {
    CloudPayments = 'cloudpayments',
    Stripe = 'stripe',
    PaySelection = 'payselection',
}

export enum PaymentMethodStatus {
    Normal = 0,
    Expiring = 1,
    Expired = 2,
}

export enum Currencies {
    Rub = 'rub',
    Eur = 'eur',
}

export enum CurrencySymbols {
    Rub = '₽',
    Eur = '€',
}
